<ng-container *ifScreenSize="screenType.Mobile">
  <div class="barcode-card">
    <ng-container *ngIf="card$ | async as card">
      <div class="upper-barcode-container d-flex flex-row align-items-center justify-content-between">
        <!--Name and ID-->
        <div class="d-flex flex-column gap-1">
          <h4
            class="member-name font-size-18 fw-bold text-uppercase mb-0 text-white"
            *ngIf="memberDetails$ | async as memberDetails"
          >
            {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
          </h4>
          <div class="d-flex flex-row align-items-center font-size-12 text-white">
            <span>{{ card.ProductCode }}</span>
            <span class="px-1">-</span>
            <span>{{ card.ExternalRefNumber }}</span>
          </div>
        </div>

        <ng-container *ngIf="isHomePage">
          <a class="wallet-button bg-glass-dark d-flex flex-row align-items-center" routerLink="/rewards/wallet">
            <span class="material-symbols-outlined text-white"> qr_code_scanner </span>
            <span class="font-size-14 text-white">{{ 'nav.wallet' | translate }}</span>
          </a>
        </ng-container>
      </div>

      <!--Balances-->
      <div
        class="balance bg-glass-dark d-flex flex-row justify-content-between align-items-center"
        [ngClass]="{ 'wallet-balance': !isHomePage }"
      >
        <span class="font-size-14 text-white text-capitalize">{{ 'barcode.your.points' | translate }}</span>

        <div class="points-container d-flex flex-row align-items-center justify-content-center">
          <span class="icons material-icons text-white" aria-hidden="true">loyalty</span>
          <span class="fw-bold text-white font-size-20 font-heading">{{ pointsBalance$ | async | number: '1.0-0' }}</span>
        </div>
      </div>
    </ng-container>

    <!-- mobile navigation -->
    <ng-container *ngIf="isHomePage">
      <ng-container *notInProductCode="[productCode.Partners]">
        <div
          #nav
          class="mobile-navigation d-flex flex-row pb-2"
          [class.at-end]="atRightEnd"
          (scroll)="onNavScroll()"
          [ngClass]="{ 'nav-center': mobileNavigationList?.length < 4 }"
        >
          <div class="navigation" routerLink="/rewards">
            <span class="icons material-symbols-outlined bg-dark-glass"> redeem</span>
            <a class="text-white font-size-14">{{ 'member.card.rewards' | translate }}</a>
          </div>

          <div class="navigation" routerLink="/rewards/events">
            <span class="icons material-symbols-outlined bg-dark-glass"> local_activity</span>
            <a class="text-white font-size-14">{{ 'member.card.events' | translate }}</a>
          </div>

          <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.games'">
            <div class="navigation" routerLink="/games">
              <span class="icons material-symbols-outlined bg-dark-glass">sports_esports </span>
              <a class="text-white font-size-14">{{ 'member.card.games' | translate }}</a>
            </div>
          </ng-container>

          <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.partners'">
            <ng-container *ngIf="displayPartner">
              <div class="navigation" routerLink="/partners">
                <span class="icons material-symbols-outlined bg-dark-glass"> group</span>
                <a class="text-white font-size-14">{{ 'member.card.partners' | translate }}</a>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *inProductCode="[productCode.Partners]">
        <div class="mobile-navigation d-flex flex-row w-100 justify-content-center gap-3 pb-2">
          <div class="navigation" routerLink="/rewards">
            <span class="icons material-symbols-outlined bg-dark-glass"> redeem </span>
            <a class="text-white font-size-14">{{ 'member.card.rewards' | translate }}</a>
          </div>

          <div class="navigation" routerLink="/rewards/events">
            <span class="icons material-icons bg-dark-glass"> local_activity </span>
            <a class="text-white font-size-14">{{ 'member.card.events' | translate }}</a>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
